module.exports = __webpack_public_path__ + "static/media/tappa.57795be4.mp3";